import { render, staticRenderFns } from "./Installations.vue?vue&type=template&id=6c1fe07a&scoped=true&"
import script from "./Installations.vue?vue&type=script&lang=js&"
export * from "./Installations.vue?vue&type=script&lang=js&"
import style0 from "./Installations.vue?vue&type=style&index=0&id=6c1fe07a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1fe07a",
  null
  
)

export default component.exports